/* Quick-add variant picker — opened for any product card whose (+) button
   carries [data-quick-add-handle] (products with real options, where an
   instant "first available variant" add would risk adding the wrong size/
   colour). Single-variant products never reach this file; they keep using
   the existing instant /cart/add.js path in custom.js.

   Real Shopify data only: product JSON is fetched fresh from
   /products/{handle}.js on every open, matching this theme's existing
   AJAX conventions (custom.js's PDP variant sync, cart-panel.js, etc.) —
   nothing here is faked or cached across products. */
document.addEventListener('DOMContentLoaded', function () {
  var modalEl = document.getElementById('quickAddModal');
  if (!modalEl) return;

  var Modal = window.bootstrap && window.bootstrap.Modal;
  var modalInstance = Modal ? new Modal(modalEl) : null;

  var loadingEl = document.getElementById('quickAddLoading');
  var bodyEl = document.getElementById('quickAddBody');
  var imgEl = document.getElementById('quickAddImg');
  var vendorEl = document.getElementById('quickAddVendor');
  var titleEl = document.getElementById('quickAddTitle');
  var priceCurrentEl = document.getElementById('quickAddPriceCurrent');
  var priceCompareEl = document.getElementById('quickAddPriceCompare');
  var optionsEl = document.getElementById('quickAddOptions');
  var errorEl = document.getElementById('quickAddError');
  var submitBtn = document.getElementById('quickAddSubmit');
  var submitTextEl = document.getElementById('quickAddSubmitText');

  var currentProduct = null;
  var selectedValues = [];
  /* The size recommended for this shopper on this product, from their size
     quiz answer or the size they last picked while shopping — the same
     answer the product page's "Recommended Size" card gives
     (assets/vro-pdp-quiz.js, VroPdpQuiz.recommendFor). Null when there is
     nothing honest to recommend. */
  var currentRec = null;

  function moneyFormat(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }
  /* Option names as normal text — "PACK SIZE VALUE" reads "Pack size
     value" — the same as the product page prints them. */
  function normalCase(text) {
    var t = String(text || '').toLowerCase();
    return t.charAt(0).toUpperCase() + t.slice(1);
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function findMatchingVariant(values) {
    if (!currentProduct) return null;
    return currentProduct.variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return values.every(function (val, i) { return val == null || opts[i] === val; });
    }) || null;
  }

  /* /products/{handle}.js gives each option as an object on current API
     versions — {name, position, values} — and as a bare string on older
     ones. Read either. Taken as a string, the object went through
     escapeHtml as "[object Object]", which is what the heading showed. */
  function optionName(opt) {
    return (opt && typeof opt === 'object') ? (opt.name || '') : (opt || '');
  }

  /* Same story for the values: the object carries its own, which are the
     option's real ones in the merchant's order. Falling back to
     options_with_values, and to deriving them from the variants, keeps
     the older shapes working. */
  function optionValues(opt, i) {
    if (opt && typeof opt === 'object' && opt.values && opt.values.length) return opt.values;
    if (currentProduct.options_with_values && currentProduct.options_with_values[i]) {
      return currentProduct.options_with_values[i].values;
    }
    return uniqueValuesFor(i);
  }

  /* Is there a variant in stock with this value at this option, given what
     is already chosen elsewhere? The other options are only honoured when
     they have been chosen, so the first render (nothing picked yet) asks
     the plain question: does any in-stock variant carry this value. */
  function hasAvailableVariant(index, value) {
    var variants = (currentProduct && currentProduct.variants) || [];
    for (var v = 0; v < variants.length; v++) {
      var variant = variants[v];
      if (!variant.available) continue;
      var opts = variant.options || [];
      if (opts[index] !== value) continue;
      var ok = true;
      for (var i = 0; i < opts.length; i++) {
        if (i === index) continue;
        if (selectedValues[i] != null && selectedValues[i] !== opts[i]) { ok = false; break; }
      }
      if (ok) return true;
    }
    return false;
  }

  /* The in-stock variant closest to `target` (one value per option). An
     earlier option counts for more than a later one, so Pack and Size
     hold on longer than Flavour. `lock` is an option index whose value
     must stay as in the target. Null when nothing in stock fits. */
  function nearestAvailable(target, lock) {
    var variants = (currentProduct && currentProduct.variants) || [];
    var best = null, bestScore = -1;
    for (var v = 0; v < variants.length; v++) {
      var variant = variants[v];
      if (!variant.available) continue;
      var opts = variant.options || [];
      if (lock != null && opts[lock] !== target[lock]) continue;
      var score = 0;
      for (var i = 0; i < opts.length; i++) {
        if (opts[i] === target[i]) score += Math.pow(2, opts.length - i);
      }
      if (score > bestScore) { best = variant; bestScore = score; }
    }
    return best;
  }

  function renderOptions() {
    optionsEl.innerHTML = currentProduct.options.map(function (opt, i) {
      var name = optionName(opt);
      var values = optionValues(opt, i);
      var chips = values.map(function (val) {
        var active = selectedValues[i] === val;
        var recommended = !!(currentRec && currentRec.index === i && currentRec.value === val);
        /* Whether any variant carrying this value can still be bought,
           read against the choices already made on the other options —
           so "M" greys out once a colour with no M left is picked, rather
           than only when the product is out of M altogether. Marked, not
           removed: a size that vanishes leaves no trace the product comes
           in it, which is what a shopper wants to know when deciding
           whether to wait for it. */
        var gone = !hasAvailableVariant(i, val);
        return '<button type="button" class="quick-add-chip' + (active ? ' is-selected' : '') + (gone ? ' is-unavailable' : '') + (recommended ? ' is-recommended' : '') + '"' + (gone ? ' aria-disabled="true" title="Out of stock"' : '') + ' data-option-index="' + i + '" data-option-value="' + escapeHtml(val) + '">' + escapeHtml(window.vroOptionLabel ? window.vroOptionLabel(val) : val) + '</button>';
      }).join('');
      return '<div class="quick-add-option-group"><p class="quick-add-option-name">' + escapeHtml(normalCase(name)) + '</p>' + recFor(i) + '<div class="quick-add-chips">' + chips + '</div></div>';
    }).join('');
  }

  /* "Recommended size for you is L / Because you wear an L in Bamboology
     this will fit you perfectly", above the size chips. */
  function recFor(i) {
    if (!currentRec || currentRec.index !== i) return '';
    var gone = !hasAvailableVariant(i, currentRec.value);
    var line = gone
      ? currentRec.value + ' is sold out in this one right now'
      : currentRec.reason;
    return '<div class="quick-add-rec">' +
      '<p class="quick-add-rec-title"><svg width="12" height="12" viewBox="0 0 28 28" aria-hidden="true"><path d="M12.28 8.33c.91-1.66 1.37-2.5 1.72-2.5s.8.84 1.71 2.5c.94 1.71 2.19 2.98 3.95 3.94 1.67.92 2.5 1.37 2.5 1.72s-.83.8-2.5 1.72c-1.71.94-2.98 2.19-3.94 3.95-.91 1.67-1.37 2.5-1.72 2.5s-.8-.83-1.72-2.5c-.94-1.71-2.19-2.98-3.95-3.94-1.67-.92-2.51-1.38-2.51-1.72s.84-.81 2.51-1.72c1.76-.97 3.01-2.23 3.95-3.94z" fill="currentColor"/></svg>' +
      'Recommended size for you is <b>' + escapeHtml(currentRec.value) + '</b></p>' +
      (line ? '<p class="quick-add-rec-text">' + escapeHtml(line) + '</p>' : '') +
      '</div>';
  }

  // Fallback if the /products/{handle}.js response doesn't include
  // options_with_values (older/rarer Shopify response shapes) — derive
  // the distinct values for option index i straight from the variants.
  function uniqueValuesFor(i) {
    var seen = [];
    currentProduct.variants.forEach(function (v) {
      var val = [v.option1, v.option2, v.option3][i];
      if (val && seen.indexOf(val) === -1) seen.push(val);
    });
    return seen;
  }

  function updateSubmitState() {
    var variant = findMatchingVariant(selectedValues);
    var allChosen = selectedValues.length === currentProduct.options.length && selectedValues.every(function (v) { return v != null; });

    if (!allChosen) {
      submitBtn.disabled = true;
      submitTextEl.textContent = 'Select options';
      errorEl.hidden = true;
      return null;
    }
    if (!variant) {
      submitBtn.disabled = true;
      submitTextEl.textContent = 'Unavailable';
      errorEl.hidden = false;
      return null;
    }

    errorEl.hidden = true;
    priceCurrentEl.textContent = moneyFormat(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceCompareEl.textContent = moneyFormat(variant.compare_at_price);
      priceCompareEl.hidden = false;
    } else {
      priceCompareEl.hidden = true;
    }

    submitBtn.disabled = !variant.available;
    submitTextEl.textContent = variant.available ? 'Add to cart' : 'Sold out';
    return variant.available ? variant : null;
  }

  function openFor(handle) {
    loadingEl.hidden = false;
    bodyEl.hidden = true;
    submitBtn.disabled = true;
    if (modalInstance) modalInstance.show();

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product) throw new Error('not found');
        currentProduct = product;
        selectedValues = product.options.map(function () { return null; });

        /* The modal opens already answered, so nobody taps through the
           options to find out what is in stock. The target is the first
           variant; the recommended size (size quiz / last size picked —
           the same one the product page uses) takes its place in the
           target when that size is in stock. The variant picked is the
           in-stock one closest to the target, which is the first variant
           itself when it can be bought. With nothing in stock the first
           variant is shown and every pill is greyed. */
        currentRec = null;
        try {
          if (window.VroPdpQuiz && window.VroPdpQuiz.recommendFor) currentRec = window.VroPdpQuiz.recommendFor(product);
        } catch (err) { currentRec = null; }

        var firstVariant = product.variants[0];
        var target = ((firstVariant && firstVariant.options) || []).slice();
        if (currentRec && hasAvailableVariant(currentRec.index, currentRec.value)) target[currentRec.index] = currentRec.value;
        var start = nearestAvailable(target, null) || firstVariant;
        if (start && start.options) selectedValues = start.options.slice();

        var img = product.featured_image || (product.images && product.images[0]) || '';
        imgEl.src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=144' : '';
        imgEl.alt = product.title;
        vendorEl.textContent = product.vendor;
        titleEl.textContent = product.title;
        priceCurrentEl.textContent = moneyFormat(product.price);
        priceCompareEl.hidden = true;

        renderOptions();
        updateSubmitState();

        loadingEl.hidden = true;
        bodyEl.hidden = false;
      })
      .catch(function () {
        loadingEl.textContent = "Couldn't load this product — try again.";
      });
  }

  optionsEl.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-option-index]');
    if (!chip) return;
    var i = Number(chip.getAttribute('data-option-index'));
    selectedValues[i] = chip.getAttribute('data-option-value');
    renderOptions();
    updateSubmitState();
  });

  submitBtn.addEventListener('click', function () {
    var variant = updateSubmitState();
    if (!variant) return;
    submitBtn.disabled = true;
    var originalText = submitTextEl.textContent;
    submitTextEl.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
    })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        if (window.updateCartCount) window.updateCartCount(cart.item_count);
        if (window.showCartToast) window.showCartToast(cart, variant.id);
        else if (window.showToast) window.showToast('Added to cart', 'cart');
        if (modalInstance) modalInstance.hide();
        // For listeners that care which product just went in — the
        // wishlist panel drops it from the wishlist (assets/wishlist.js).
        document.dispatchEvent(new CustomEvent('vro:quick-add-success', { detail: { handle: currentProduct && currentProduct.handle } }));

        // Reuses the exact same open+refresh pipeline as every other real
        // click on the cart icon (theme.liquid's openPanel + cart-panel.
        // js's refreshPanel, both delegated off this same attribute).
        // Desktop only — on a phone the toast is the whole of it; see
        // openCartPanelAfterAdd in custom.js.
        if (window.openCartPanelAfterAdd) window.openCartPanelAfterAdd();
      })
      .catch(function () {
        if (window.showToast) window.showToast('Could not add — try again');
      })
      .finally(function () {
        submitBtn.disabled = false;
        submitTextEl.textContent = originalText;
      });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add-handle]');
    if (!btn) return;
    e.preventDefault();
    openFor(btn.getAttribute('data-quick-add-handle'));
  });
});
